import { Component, OnInit } from '@angular/core';
import { TicketFilterItem } from '../ticket-filter/ticket-filter.component';

@Component({
    selector: 'app-ticket-sort',
    templateUrl: './ticket-sort.component.html',
    styleUrls: ['./ticket-sort.component.scss', '../ticket-filter/ticket-filter.component.scss'],
    standalone: false
})
export class TicketSortComponent implements OnInit {

  public sortValue: string = "newest"
  public newValueSelected: (data: TicketFilterItem) => void

  public sortItems: TicketFilterItem[] = [
    {id: 1, typeText: "newest", description: "Neueste", icon: "fa-sparkles"},
    {id: 2, typeText: "oldest", description: "Älteste", icon: "fa-person-old"},
    {id: 3, typeText: "priorityhigh", description: "Priorität Hoch", icon: "fa-arrow-up-right"},
    {id: 4, typeText: "prioritylow", description: "Priorität Niedrig", icon: "fa-arrow-down-right"},
  ]

  constructor() { }

  ngOnInit() {}

  public select(value: string){
      this.newValueSelected(this.sortItems.find(item => item.typeText === value))
  }

}
